import React from 'react';
import { useAutoScrollPage } from './AutoScrollPage';
import { TermsPoliciesContainer } from './TermsPoliciesContainer';

export const TermsPage = () => {
    const { scrollToHash } = useAutoScrollPage();

    return <TermsPoliciesContainer type={'terms'} onContentLoaded={scrollToHash} />;
}
